import BottomLinks from '../../components/portfolioBottomLinks'
import Interested from '../../components/interestedComponent'
import PortfolioBody from '../../components/portfolioBody'
import PortfolioHeader from '../../components/portfolioHeader'

const BenchWitch = () => {
  return (
    <div className='desktop-width'>
      <PortfolioHeader image='/images/portfolio/benchwitch/benchwitch_header.png' />

      <PortfolioBody
        header='BenchWitch'
        smallText='A tap-to-track stats app for roller derby coaches, built to sync live across tablets with Cloudflare Durable Objects, D1, and Workers AI. The repo is private, so the design deck and my DevFest DC talk are shared here.'
        description={[
          'Bench coaches notice patterns, like a jammer who always breaks out on the inside on turn four, but two-minute jams leave no time to write anything down. BenchWitch turns that instinct into evidence. One tap on the track marks where a jammer exits the pack, three buttons record the lead jammer, star pass, and points, and heat maps reveal the patterns afterward. It started as a page in my notebook, and with playoffs 30 days out it became a working app for my team’s coaches.',
          'The design deck covers the problem, the loop a coach repeats every two minutes, the core features, the data model, and the tech stack. It also sets six UX principles for an app used at the bench: track first, big targets, one tap over two, glanceable, forgiving, and light and offline. The rule of thumb is that if a jam takes more than eight taps, the design failed.',
          'My DevFest DC talk, “Two Tablets, One Bench,” covers how it works. Each game gets its own Durable Object that holds the canonical snapshot in memory and fans changes out over WebSockets to every tablet, with D1 as a best-effort backup. Timestamps decide which write wins, games are shared with a QR code and a short game code instead of a login, and a read-only third device can follow along. A scheduled Worker keeps WFTDA rankings fresh, and when a bout is finalized, Workers AI writes a short plain-language summary from pre-computed stats, because coaches wanted a paragraph, not another table. The previews below start with the live app, using the summary from a game I tracked at DevFest, followed by slides from the design deck and the talk.',
        ]}
        links={
          <div>
            <a
              href='/pdf/KendalBrown_BenchWitch_Design_Deck.pdf'
              target='_blank'
              rel='noreferrer'
            >
              Design Deck (PDF)
            </a>
            <a
              href='/pdf/KendalBrown_BenchWitch_DevFest_2026.pdf'
              target='_blank'
              rel='noreferrer'
            >
              DevFest DC Presentation (PDF)
            </a>
          </div>
        }
        techStack={{
          coding: [
            'React',
            'TypeScript',
            'Vite',
            'Material UI (MUI)',
            'SVG and Pointer Events',
            'heatmap.js',
            'IndexedDB',
            'WebSockets',
            'Cloudflare Pages',
            'Cloudflare Workers',
            'Cloudflare Durable Objects',
            'Cloudflare D1',
            'Workers AI',
            'GitHub Actions',
          ],
          design: [
            'Design deck',
            'Six UX principles',
            'Touch-first design',
            'Local-first and offline design',
            'Heat map data visualization',
            'MUI theme tokens',
            'WCAG accessibility guidelines',
          ],
        }}
        images={[
          {
            src: '/images/portfolio/benchwitch/benchwitch_live_overview.png',
            alt: 'The live BenchWitch game summary showing the final score of 16 to 34, a whole-bout heat map of pack exits on the track, top scorers, and top lead percentage',
          },
          {
            src: '/images/portfolio/benchwitch/benchwitch_live_charts.png',
            alt: 'The live BenchWitch summary with score progression and blocker penalty progression charts, plus per-team stats for average points per jam, star passes, biggest jam, and lead percentage',
          },
          {
            src: '/images/portfolio/benchwitch/benchwitch_live_analysis.png',
            alt: 'The live BenchWitch AI jammer analysis, a written summary of each jammer’s performance generated by Workers AI from the bout stats',
          },
          {
            src: '/images/portfolio/benchwitch/benchwitch_design_tracker.png',
            alt: 'BenchWitch design deck slide for the live track tap tracker, showing a tablet with the track, both team scores, and lead, pivot, and points controls',
          },
          {
            src: '/images/portfolio/benchwitch/benchwitch_design_heatmaps.png',
            alt: 'BenchWitch design deck slide showing four heat map views: single jam, single jammer, one team, and both teams',
          },
          {
            src: '/images/portfolio/benchwitch/benchwitch_talk_architecture.png',
            alt: 'DevFest DC talk slide with the BenchWitch architecture diagram: tablets connect over WebSockets to a Sync Worker with a GameRoom Durable Object, backed up to D1, plus a weekly Rankings Worker that scrapes WFTDA',
          },
          {
            src: '/images/portfolio/benchwitch/benchwitch_talk_websocket.png',
            alt: 'DevFest DC talk slide showing the WebSocket join flow between two tablets and the GameRoom Durable Object, including evicting the old socket when the same client reconnects',
          },
        ]}
      />

      <BottomLinks
        linkOne='/portfolio/vibekit'
        linkOneText='VibeKit'
        linkTwo='/portfolio/weather-app'
        linkTwoText='Weather App'
      />
      <Interested />
    </div>
  )
}

export default BenchWitch
